"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRContent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = require("../breakpoints");
var _LexusTypography = require("../LexusTypography");
/**
 * This is an escape hatch component option for us to use within
 * `<CopyBlock>` and `<Text>` to apply the GR specific typography styles
 * with the specificity needed to win out over the other elements with
 * Nobel font styles baked in.
 */
const GRContent = exports.GRContent = _styledComponents.default.div`
	h1, h2, h3, h4, h5, h6, .heading {
		${(0, _LexusTypography.decimaMonoPro)({
  weight: "light",
  sizing: "heading40"
})}
		${(0, _breakpoints.breakpoint)("tablet", "down")} {
			${(0, _LexusTypography.decimaMonoPro)({
  weight: "light",
  sizing: "heading32"
})}
		}
	}
	&, p, .paragraph {
		${(0, _LexusTypography.akkuratMono)({
  weight: "regular",
  sizing: "body16"
})}
	}
`;